export default `<p id="isPasted">
  <span style="font-size: 24px"
    ><strong>${new Date().getFullYear()}校园招聘简章</strong></span
  >
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  <span style="font-size: 18px"><strong>一、单位简介：</strong></span>
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp;
  我单位原名称为“电力工业电力设备及线路器材质量检验测试中心”,于1990年由原能源部以《人组【1990】035号》文设立，目前中心已发展成行业权威的第三方检验机构，是独立的事业法人单位。目前中心主要业务范围包括输电线路铁塔、输变电钢管结构产品（钢管杆、钢管塔及钢管构支架）、环形混凝土电杆、电缆导管、电力金具及水工金属结构（压力钢管、钢闸门）等产品检测。自主开发的智能制造管控系统帮助生产企业实现了&ldquo;互联网+&rdquo;的战略目标，现已被相关行业的企业正式应用到生产管理中，成为其不可或缺的管理工具，效果显著。因业务拓展，需招聘软件开发和测试岗位10名。
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  <strong
    style="box-sizing: border-box; font-weight: 700; padding: 0px; margin: 0px"
    ><span style="font-size: 18px">二、招聘条件：</span></strong
  >
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 1.能按期取得毕业证及学位证；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 2.具备良好的人际沟通及表达能力，工作认真踏实，善于钻研；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 3.熟悉软件开发流程，思路清晰，具备良好的分析和解决问题的能力；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 4.掌握C#/Java/python等一种面向对象开发语言；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 5.熟悉常用的关系数据库SQL Server、Oracle、MySQL其中之一；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 6.熟悉Linux命令、熟悉git常用命令优先考虑；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp;
  7.使用HTML5、CSS、JavaScript熟练地进行页面开发；了解前端三大框架，vue优先考虑；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 8.学习过相关AI人工智能技术优先考虑；
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 9.有计算机图形图像学基础，掌握一定的图形算法优先考虑。
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  <strong
    style="box-sizing: border-box; font-weight: 700; padding: 0px; margin: 0px"
    ><span style="font-size: 18px">三</span></strong
  ><span style="font-size: 18px"
    ><strong
      style="
        box-sizing: border-box;
        font-weight: 700;
        padding: 0px;
        margin: 0px;
      "
      >、</strong
    ><strong
      style="
        box-sizing: border-box;
        font-weight: 700;
        padding: 0px;
        margin: 0px;
      "
      >招聘专业与岗位</strong
    ><strong
      style="
        box-sizing: border-box;
        font-weight: 700;
        padding: 0px;
        margin: 0px;
      "
      >（</strong
    ></span
  ><strong
    style="box-sizing: border-box; font-weight: 700; padding: 0px; margin: 0px"
    ><span style="font-size: 18px">10名）</span></strong
  >
</p>
<table style="width: 30%; margin-right: calc(70%)">
  <tbody>
    <tr>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 7.6224%;
          text-align: center;
          background-color: rgb(204, 204, 204);
          vertical-align: middle;
        "
      >
        <div data-empty="true" style="text-align: center"><br /></div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 40.7813%;
          text-align: center;
          background-color: rgb(204, 204, 204);
        "
      >
        <div style="text-align: center">专业类别名称</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 27.2846%;
          text-align: center;
          background-color: rgb(204, 204, 204);
        "
      >
        <div style="text-align: center">岗位</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 23.9992%;
          text-align: center;
          background-color: rgb(204, 204, 204);
        "
      >
        <div style="text-align: center">招聘人数</div>
      </td>
    </tr>
    <tr>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 7.6224%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">1</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 40.7813%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">计算机相关专业</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 27.2846%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">研发工程师</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 23.9992%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">5</div>
      </td>
    </tr>
    <tr>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 7.6224%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">2</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 40.7813%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">计算机相关专业</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 27.2846%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">测试工程师</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 23.9992%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">3</div>
      </td>
    </tr>
    <tr>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 7.6224%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">3</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 40.7813%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">专业不限</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 27.2846%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">需求工程师</div>
      </td>
      <td
        class="fr-thick fr-highlighted"
        style="
          width: 23.9992%;
          text-align: center;
          background-color: rgb(239, 239, 239);
        "
      >
        <div style="text-align: center">2</div>
        <div style="text-align: center"></div>
      </td>
    </tr>
  </tbody>
</table>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  <span style="font-size: 18px"><strong>四、</strong></span
  ><strong
    style="box-sizing: border-box; font-weight: 700; padding: 0px; margin: 0px"
    ><span style="font-size: 18px"><strong>校园招聘流程</strong></span></strong
  >
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp;
  校园招聘程序：企业宣讲&rarr;现场投递纸制简历（含成绩单）&rarr;面试/笔试&rarr;录用座谈&rarr;签订就业协议
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  <strong><span style="font-size: 18px">五、联系方式：</span></strong>
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 联系电话：0591-87555927-809 &nbsp; &nbsp; 18605915933 &nbsp;
  &nbsp;&nbsp;
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 传真：0591-87555927-808
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; E-Mail: fzgddl@126.com
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 地址：福建省福州市高新区海西园
</p>
<p
  style="
    box-sizing: border-box;
    margin: 10px 0px;
    padding: 0px;
    line-height: 1.5;
    font-size: 16px;
    color: rgb(51, 51, 51);
    font-family:
      &quot;Helvetica Neue&quot;, Helvetica, Arial,
      &quot;Hiragino Sans GB&quot;, &quot;Hiragino Sans GB W3&quot;,
      &quot;Microsoft YaHei UI&quot;, &quot;Microsoft YaHei&quot;,
      &quot;WenQuanYi Micro Hei&quot;, sans-serif;
    font-style: normal;
    font-variant-ligatures: normal;
    font-variant-caps: normal;
    font-weight: 400;
    letter-spacing: normal;
    orphans: 2;
    text-align: left;
    text-indent: 0px;
    text-transform: none;
    white-space: normal;
    widows: 2;
    word-spacing: 0px;
    -webkit-text-stroke-width: 0px;
    background-color: rgb(255, 255, 255);
    text-decoration-thickness: initial;
    text-decoration-style: initial;
    text-decoration-color: initial;
  "
>
  &nbsp; &nbsp; 邮编：350109
</p>`